module.exports = __webpack_public_path__ + "static/media/sound5.d878789a.mp3";